import React, { FC, useEffect, useState } from 'react';
import { Container, CustomCreatableSelect, StyledLabel } from './styles';
import { Props as SelectProps } from 'react-select';

export interface CreatableSelectProps extends SelectProps {
    label: string;
}

const Creatable: FC<CreatableSelectProps & any> = ({
    options,
    value,
    onChange,
    label,
    ...rest
}) => {
    const [localOptions, setLocalOption] = useState<any[]>(value || []);
    const [focused, setFocused] = useState(false);

    useEffect(() => {
        setLocalOption(value || '');
    }, [value]);

    return (
        <Container>
            <CustomCreatableSelect
                {...rest}
                value={value}
                onChange={(value: any, action: any) => {
                    setLocalOption(value);
                    return onChange?.(value, action);
                }}
                options={options}
                className='customSelect'
                classNamePrefix='customSelectEls'
                placeholder=''
                onFocus={(ev: any) => {
                    setFocused(true);
                    rest.onFocus?.(ev);
                }}
                onBlur={(ev: any) => {
                    setFocused(false);
                    rest.onFocus?.(ev);
                }}
            />
            <StyledLabel active={focused || localOptions.length !== 0}>{label}</StyledLabel>
        </Container>
    );
};

export { Creatable };
